import React from 'react';
import { useParams } from 'react-router';
import { RoutedComponentProps } from 'src/app-routes';
import { ViewInspirationalImagesGalleryPage } from 'src/components-bl/Galleries';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { GalleryType, InspirationalImagesGallery } from 'src/services';

interface ViewInspirationalImagesGalleryContainerProps extends RoutedComponentProps {
  shopId: number;
}

export const ViewInspirationalImagesGalleryContainer = ({
  shopId,
  permittedRouteMap,
}: ViewInspirationalImagesGalleryContainerProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const { galleryId } = useParams<{ galleryId: string }>();

  const gallery = useAppSelector(state =>
    state.galleries.currentGallery?.galleryType === GalleryType.InspirationalImage
      ? (state.galleries.currentGallery as InspirationalImagesGallery)
      : undefined
  );
  return (
    <ViewInspirationalImagesGalleryPage
      dispatch={dispatch}
      gallery={gallery}
      galleryId={galleryId}
      permittedRouteMap={permittedRouteMap}
      shopId={shopId}
    />
  );
};
